import { Link } from 'react-router';
import cn from 'classnames';

import useMartyContext from 'hooks/useMartyContext';
import { constructLayeredMsaImageSizingPositioning, constructLayeredMsaImageUrl, constructMSAImageUrl } from 'helpers';
import { FILE_NAME_NO_EXT } from 'common/regex';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import css from 'styles/components/cart/productImage.scss';
import { imageNoBackground, mCard, image as mImage } from 'styles/components/common/melodyCard.scss';

const imageDimensions = { width: 500, height: 500, autoCrop: true };
const layeredImageSizing = constructLayeredMsaImageSizingPositioning(500);

export const ProductImage = ({ item, className, dataTe, tabIndex = 0, ariaHidden = false, ...rest }) => {
  const { testId, marketplace: { shortName, isTsdImage } } = useMartyContext();

  const {
    imageId,
    imageUrl,
    image: { defaultUrl } = {},
    egc,
    asin,
    productId,
    brandName,
    brand,
    style,
    productName,
    recoName
  } = item;

  let link = '';
  let alt = '';
  const parsedImageId = imageId ? imageId : (imageUrl || defaultUrl).match(FILE_NAME_NO_EXT)[0];
  const catalogueBundleImages = item.catalogBundle?.tsdImages;
  let botImageId, topImageId;
  if (catalogueBundleImages) {
    topImageId = catalogueBundleImages.imageIds?.[0];
    botImageId = catalogueBundleImages.backgroundId;
  }

  let url;
  if (isTsdImage && topImageId && botImageId) {
    url = constructLayeredMsaImageUrl({
      ...layeredImageSizing,
      topImageId,
      botImageId
    });
  } else {
    url = constructMSAImageUrl(parsedImageId, imageDimensions);
  }
  if (egc) {
    link = '/egiftcard';
    alt = `${shortName} Gift Card`;
  } else {
    link = asin ? `/p/asin/${asin}` : `/product/${productId}`;
    alt = `${brandName || brand} ${productName || style}`;
  }

  link = recoName ? `${link}?ref=${recoName}` : link;

  return (
    <div className={cn(css.container, mCard, className)} {...rest}>
      <Link
        data-test-id={testId('cartItemImage')}
        tabIndex={tabIndex}
        aria-hidden={ariaHidden}
        to={link}
        data-te={dataTe || 'TE_CART_PRODUCTCLICKED'}
        data-ted={asin}
        className={cn(mImage, { [imageNoBackground]: isTsdImage })}>
        <img src={url} alt={alt} data-test-id={testId('imageSrc')}/>
      </Link>
    </div>
  );
};

const WithErrorBoundaryProductImage = withErrorBoundary('ProductImage', ProductImage);
export default WithErrorBoundaryProductImage;
